import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApisService } from "app/services/apis.service";
import { Subject } from "rxjs";
import { Utils } from "../../../../shared/utils";
import { environment } from "environments/environment.staging";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileComponent implements OnInit, OnDestroy {
  // Public Variables
  utils: Utils;
  public profileData: any;
  public userData: any;
  public userNetworks: any[] = [];
  public userActivities: any[] = [];
  public mentionedUsers: any[] = [];
  public totalUserNetworks = 0;
  public toggleMenu = true;
  public isMonthlyPlan = false;
  public toggleNavbar = false;
  public isLoadingMore = false;
  public userId :any
  public services : any
  public expandedDescriptions: { [key: string]: boolean } = {};
  public activePill: 'feed' | 'userServices' | 'home' = 'home';

  public tabs : 'about' | 'networks' | 'overview' = 'about';
  public userStats : any

  // Private Variables
  private _unsubscribeAll: Subject<any>;

  constructor(private apiService: ApisService, private route: ActivatedRoute) {
    this.utils = new Utils();
    this._unsubscribeAll = new Subject();
  }

  // 🔹 Lifecycle Hooks
  ngOnInit(): void {
    // Fetch User Profile using Query Params
    const userId = this.route.snapshot.params["id"];
    this.fetchUserProfile(userId);
    this.fetchUserNetwork(userId);
    this.fetchUserActivities(userId);
    this.getServices(userId);
    this.getUserStats();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // 🔹 API Calls
  private fetchUserProfile(userId: string): void {
    this.apiService.getUserProfile(userId).subscribe({
      next: (response: any) => {
        this.userData = response.data;
      },
      error: (err) => {
        console.error("Error fetching user profile:", err);
      },
    });
  }

  private fetchUserNetwork(userId: number): void {
    this.apiService.getUserNetwork(userId, 10, 0).subscribe({ 
      next: (response: any) => {
        if (response?.data?.items && Array.isArray(response.data.items)) {
          // Map the response to format it for the UI
          this.totalUserNetworks = response.data.total || 0;
          this.userNetworks = response.data.items.map((user) => ({
            id: user.id,
            name: `${user.firstName} ${user.lastName}`,
            avatar: user.media?.url
              ? environment.mediaUrl + "/" + `${user.media.url}`
              : "assets/images/goalngo/profile.svg",
            city: user.city || "Unknown City",
            country: user.country?.name || "Unknown Country",
            role: user.role || "N/A",
          }));
          console.log("User Networks:", this.userNetworks);
        } else {
          this.userNetworks = [];
        }
      },
      error: (err) => {
        console.error("Error fetching user networks:", err);
        this.userNetworks = [];
      },
    });
  }

  fetchUserActivities(userId: number): void {
    this.apiService.getUserActivities(userId).subscribe({
      next: (response: any) => {
        this.userActivities = response.data?.items || [];
        this.userActivities= this.userActivities.filter((item: any) => item.postType !== 'SERVICE');
        console.log(this.userActivities)
        this.mentionedUsers = response.data?.mentionedUsers || [];
      },
      error: (err) => {
        console.error("Error fetching user activities:", err);
      },
    });
  }

  /*----------  Get Service by userId  ----------*/
getServices(userId:any) { 
  this.apiService.serviceByUserId(userId).subscribe({
    next: (response: any) => {
      this.services = response.data?.items
      console.log("response" , response);
    }, 
    error(err) {
      console.log("error in fetching data", err);
    },
  })
}


/*----------  Toggling description  ----------*/
toggleDescription(serviceId: string): void {
  this.expandedDescriptions[serviceId] = !this.expandedDescriptions[serviceId];
}

isExpanded(serviceId: string): boolean {
  return !!this.expandedDescriptions[serviceId];
}


/*----------  get user stats  ----------*/
getUserStats(){ 
  this.apiService.getUserStats().subscribe({
    next: (response: any) => {
      console.log("response" , response);
      this.userStats = response.data
    }, 
    error(err) {
      console.log("error in fetching data", err);
    },
  })
}


/*----------  Suspend Service  ----------*/
suspendService(serviceId:any , data : any){
  this.apiService.suspendService(serviceId ).subscribe({
    next: (response: any) => {
      console.log("response" , response);
      this.getServices(this.userId);
    }, 
    error(err) {
      console.log("error in fetching data", err);
    },
  })
}

/*----------  Handle Incorrect image fetching  ----------*/
handleImageError(event: any) {
  const imgElement = event.target as HTMLImageElement;
  imgElement.src = "assets/images/logo/logo.svg";
}


}
